import { Body, Header, Row, Table as CustomTableElement, TD, TH } from './CustomTable'

const CustomTable = Object.assign(CustomTableElement, { Header, TH, Body, Row, TD })

export default CustomTable
